import React from 'react';
import { Chat, Prompt } from '../../types';
import { CHAT_TYPE_GENERAL } from '../../dto';
import { ChatListAndMessenger } from '../components/ChatListAndMessenger';

export const ChatTab = (props: {
  selectedChat: Chat | null;
  onChatSelected: (chat: Chat) => void;
  onOpenLibraryClick: () => void;
  onOpenVariablesClick: () => void;
  onPromptClick: (prompt: Prompt) => void;
}) => {
  const { selectedChat, onChatSelected, onOpenLibraryClick, onOpenVariablesClick, onPromptClick } =
    props;
  return (
    <ChatListAndMessenger
      chatType={CHAT_TYPE_GENERAL}
      selectedChat={selectedChat}
      onChatSelected={onChatSelected}
      onOpenLibraryClick={onOpenLibraryClick}
      onOpenVariablesClick={onOpenVariablesClick}
      onPromptClick={onPromptClick}
    />
  );
};
